export const getIsElectronTag = () => (window.electron ? 'true' : 'false');
